module.exports = __webpack_public_path__ + "be77b0a5e17865d5fb70f1c28810db3f.png";